module.exports = __webpack_public_path__ + "img/20190613162011383.02328c64.png";